import { Button, Group } from '@mantine/core';
import { IconShare, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './DocumentSelectionBanner.module.scss';
import { Props } from './DocumentSelectionBanner.types';

// t('documentSelection.selected_one', '{{count}} fichier sélectionné')
// t('documentSelection.selected_other', '{{count}} fichiers sélectionnés')

const DocumentSelectionBanner = ({ count, onDeleteClick, onShareClick, shareLoading }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.selectionText}>{t('documentSelection.selected', { count })}</div>
      <Group>
        <Button
          variant="light"
          color="blue"
          leftSection={<IconShare size={18} />}
          onClick={onShareClick}
          loading={shareLoading}
        >
          {t('documentSelection.share', 'Partager')}
        </Button>
        <Button
          variant="light"
          color="red"
          leftSection={<IconTrash size={18} />}
          onClick={onDeleteClick}
        >
          {t('documentSelection.delete', 'Supprimer')}
        </Button>
      </Group>
    </div>
  );
};

export default DocumentSelectionBanner;
